import {
	API_AWARD_FEED,
	API_SUBAWARD_FEED,
	DEFAULT_PAGE_LIMIT,
} from "globals/constants";
import { spUrl } from "utils";
import {
	buildSearchParams,
	request,
	save,
} from "utils/proxy";


export const modifications = {
	cancel: (url, body, options = {}) =>
		save(spUrl(`${url}/modifications/cancel`), body, options),

	update: (url, searchParams, body, options = {}) =>
		save(spUrl(`${url}/modifications${buildSearchParams(searchParams)}`), body, options),

	complete: (url, searchParams, body, options = {}) =>
		save(spUrl(`${url}/modifications/complete${buildSearchParams(searchParams)}`), body, options),

	completeAndReRoute: (url, searchParams, body, options = {}) =>
		save(spUrl(`${url}/modifications/complete-and-re-route/${buildSearchParams(searchParams)}`), body, options),

	get: (baseUrl, searchParams, options = { retries: 0 }) => {
		const sp = {
			search: searchParams.search,
			size: searchParams.size || DEFAULT_PAGE_LIMIT,
			page: searchParams.page || "0",
		};

		return request(spUrl(`${baseUrl}/modifications${buildSearchParams(sp)}`, options));
	},

	getAwardModifications: (params, searchParams, options = {}) =>
		modifications.get(`${API_AWARD_FEED}/${params.formId}`, searchParams, options),

	getSubawardModifications: (params, searchParams, options = {}) =>
		modifications.get(`${API_SUBAWARD_FEED}/${params.formId}`, searchParams, options),
};
